import { Koi } from '@ksyos/koi';
import type { IAllergy } from '@common/validation/allergy';
import type { ILabResult } from '@common/validation/labResult';
import { allergySchema } from '@common/validation/allergy';
import { labResultSchema } from '@common/validation/labResult';
import type { IEpisodesAndJournals } from '../episodesAndJournal';
import { episodesAndJournalEntriesSchema } from '../episodesAndJournal';

export type ProcessActivityProfessionalSummaryData = {
    allergies: IAllergy[];
    episodesAndJournals: IEpisodesAndJournals;
    labResults: ILabResult[];
};

export const processActivityProfessionalSummaryDataSchema = Koi.object({
    allergies: Koi.array().items(allergySchema).optional(),
    episodesAndJournals: episodesAndJournalEntriesSchema.optional(),
    labResults: Koi.array().items(labResultSchema).optional(),
});

export const initialEpisodesAndJournals: IEpisodesAndJournals = {
    episodes: [],
    journalEntries: [],
};

export const processActivityInitialProfessionalSummaryData: ProcessActivityProfessionalSummaryData = {
    allergies: [],
    episodesAndJournals: { ...initialEpisodesAndJournals },
    labResults: [],
};
